import { reportDiagnostic } from '../lib/diagnostics.js'
import { useEffect } from 'react'

export default function ErrorAlert({
  title = 'Something went wrong',
  message,
  details,
  className = '',
  severity = 'error',
  source,
}) {
  useEffect(() => {
    if (!message) return
    reportDiagnostic({ severity, source: source || 'ErrorAlert', title, message, details })
  }, [title, message, details, severity, source])

  if (!message) return null

  const palette = severity === 'warning'
    ? 'bg-amber-50 border-amber-200 text-amber-900'
    : severity === 'info'
      ? 'bg-sky-50 border-sky-200 text-sky-900'
      : 'bg-rose-50 border-rose-200 text-rose-900'

  return (
    <div role="alert" className={`rounded-lg border px-4 py-3 ${palette} ${className}`}>
      <div className="font-semibold">{title}</div>
      <div className="text-sm mt-1">{message}</div>
      {details ? (
        <pre className="mt-2 text-xs whitespace-pre-wrap opacity-80">{String(details)}</pre>
      ) : null}
    </div>
  )
}
